// Composes the current datetime with a random number to guarantee a unique identifier.
const uid = () => Date.now() + Math.floor(Math.random() * 1000);

export default uid;
